import { t as defaultT } from '@app/i18n';
import { SCREENS } from '@app/constants/navigation';

import HomeStep from '@app/images/svg/userTutorial/tour-benefits.svg';
import AccountStep from '@app/images/svg/userTutorial/tour-account.svg';
import ChatStep from '@app/images/svg/userTutorial/tour-ask-bennie.svg';
import MarketplaceStep from '@app/images/svg/userTutorial/tour-marketplace.svg';
import DoctorStep from '@app/images/svg/userTutorial/tour-find-a-doctor.svg';

export const getSteps = (isMobile, t = defaultT) => {
  const STEPS = [
    {
      title: t(`userTutorial.home.title`),
      content: t(`userTutorial.home.description`),
      target: isMobile ? `#app` : `.${SCREENS.HOME}`,
      placement: isMobile ? 'center' : 'right-start',
      disableBeacon: true,
      InnerComponent: <HomeStep />,
    },
    {
      title: t(`userTutorial.askBennie.title`),
      content: t(`userTutorial.askBennie.description`),
      target: isMobile ? `#app` : '#chat',
      placement: isMobile ? 'center' : 'top-end',
      InnerComponent: <ChatStep />,
    },
    {
      title: t(`userTutorial.marketplace.title`),
      content: t(`userTutorial.marketplace.description`),
      target: isMobile ? `#app` : `.${SCREENS.MARKETPLACE}`,
      placement: isMobile ? 'center' : 'right-start',
      InnerComponent: <MarketplaceStep />,
    },
    {
      title: t(`userTutorial.findADoctor.title`),
      content: t(`userTutorial.findADoctor.description`),
      target: isMobile ? `#app` : `.${SCREENS.FIND_A_DOCTOR}`,
      placement: isMobile ? 'center' : 'right-start',
      InnerComponent: <DoctorStep />,
    },
    {
      title: t(`userTutorial.profile.title`),
      content: t(`userTutorial.profile.description`),
      target: isMobile ? `#app` : `.${SCREENS.ACCOUNT}`,
      placement: isMobile ? 'center' : 'right-start',
      InnerComponent: <AccountStep />,
    },
  ];

  return STEPS;
};
